import { navigationReducer } from '@employee/simplenavigation';
import { footerReducer } from '@employee/footer';
import layoutReducer from './modules/layout';

export default {
    navigation: navigationReducer,
    footer: footerReducer,
    layout: layoutReducer
};
